<template>

<app-view-list-field :is-condensed="isCondensed" :is-sticky="isSticky" :field="field" :filter="filter">

    <div class="image" v-lazy:background-image="image" :data-size="field.size" :style="style" v-on:click="onAvatarClick" v-tooltip="'Click to see more details'" />

</app-view-list-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item' ,'isCondensed', 'isSticky'],

    computed: {

        image: function() {

            return this.$util.thumbnail.game[(this.field.size === 'natural') ? 'natural' : 'medium'](this.item.game)

        },

        style: function() {

            var style = {}

            if (this.field.size === 'square') {

                style.borderRadius = this.field.radius.toString() + '%'

            }

            return style

        }

    },

	methods: {

		onAvatarClick: function(e) {

			if (e.shiftKey) {

				this.$util.bgg.open.game(this.item.game.id)

			} else {

				this.$pubsub.$emit('expand.open', {
					id: this.item.game.id
				})

			}

		}

	}

}

</script>

<style scoped>

.image {
	width: 48px;
	height: 48px;
	background-position: 50% 50%;
    background-repeat: no-repeat;
	cursor: pointer;
}

.field.is-condensed .image {
    width: 24px;
    height: 24px;
    margin-left: 24px;
}

.image[data-size="natural"] {
	background-size: contain;
}

.image[data-size="square"] {
	background-size: cover;
}

</style>